import TeamsTable from './TeamsTable.vue';
export default TeamsTable;
